export enum TemplateTypes {
  ButtonLabel = 1,
  HTML = 2,
  SMS = 3,
  Text = 4,
}
